import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

export type SortDirection = 'asc' | 'desc' | null;

interface SortableHeaderProps {
  label: string;
  sortKey: string;
  currentSortKey: string | null;
  currentDirection: SortDirection;
  onSort: (key: string, direction: SortDirection) => void;
  align?: 'left' | 'right' | 'center';
}

export function SortableHeader({
  label,
  sortKey,
  currentSortKey,
  currentDirection,
  onSort,
  align = 'left',
}: SortableHeaderProps) {
  const isActive = currentSortKey === sortKey;
  
  const handleClick = () => {
    if (!isActive) {
      onSort(sortKey, 'asc');
    } else if (currentDirection === 'asc') {
      onSort(sortKey, 'desc');
    } else {
      onSort(sortKey, null);
    }
  };

  const alignClass = {
    left: 'justify-start',
    right: 'justify-end',
    center: 'justify-center',
  }[align];

  return (
    <th
      className={`px-4 py-3 text-sm font-medium cursor-pointer select-none hover:bg-gray-100 transition-colors text-${align}`}
      style={{ color: 'var(--text-secondary)', backgroundColor: 'var(--light-gray-primary)' }}
      onClick={handleClick}
    >
      <div className={`flex items-center gap-1 ${alignClass}`}>
        <span>{label}</span>
        {isActive ? (
          currentDirection === 'asc' ? (
            <ArrowUp size={14} className="text-blue-600" />
          ) : (
            <ArrowDown size={14} className="text-blue-600" />
          )
        ) : (
          <ArrowUpDown size={14} className="opacity-40" />
        )}
      </div>
    </th>
  );
}
